import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "../components/site/Reveal";

const SCENARIOS = [
  { name: "Documentos", flow: ["Entrada", "IA", "Automatización", "Archivo listo"] },
  { name: "Solicitudes", flow: ["Solicitud", "IA", "Clasificación", "Asignada"] },
  { name: "Aprobaciones", flow: ["Petición", "Reglas", "Workflow", "Aprobada"] },
  { name: "Notificaciones", flow: ["Evento", "Trigger", "Automatización", "Aviso enviado"] },
  { name: "Reportes", flow: ["Datos", "Pipeline", "Automatización", "Dashboard"] },
  { name: "Procesos internos", flow: ["Tarea", "IA", "Orquestación", "Completada"] },
  { name: "Integración entre sistemas", flow: ["Sistema A", "API", "Automatización", "Sistema B"] },
];

export const Automation = () => (
  <section className="relative py-28 md:py-36" data-testid="automation-section">
    <div className="mx-auto max-w-7xl px-6">
      <SectionHeading
        eyebrow="Automatización"
        title={<>Menos tareas repetitivas. <span className="text-gradient">Más capacidad para crecer.</span></>}
        copy="Cada proceso manual es una oportunidad: lo convertimos en un flujo automático, trazable e inteligente."
        testId="automation-heading"
      />
      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SCENARIOS.map((s, i) => (
          <Reveal key={s.name} delay={(i % 3) * 0.1} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
            <div className="group h-full rounded-2xl border border-[var(--line)] bg-[var(--surface)]/60 p-6 transition-colors hover:border-[var(--cyan)]/40" data-testid={`automation-${i}`} data-cursor="card">
              <h3 className="text-base font-bold">{s.name}</h3>
              <div className="mt-5 flex flex-wrap items-center gap-y-2">
                {s.flow.map((f, j) => (
                  <span key={f} className="flex items-center">
                    <span className={`mono rounded-md px-2.5 py-1 text-[10px] tracking-wider ${j === s.flow.length - 1 ? "bg-[var(--green)]/15 text-[var(--green)]" : "bg-[var(--surface2)] text-[var(--muted)]"}`}>
                      {f}
                    </span>
                    {j < s.flow.length - 1 && <ArrowRight size={11} className="mx-1.5 text-[var(--cyan)]/60" />}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.2}>
          <div className="flex h-full flex-col justify-center rounded-2xl border border-dashed border-[var(--green)]/40 bg-[var(--green)]/5 p-6">
            <p className="text-base font-bold">¿Tienes otro proceso en mente?</p>
            <p className="mt-2 text-sm text-[var(--muted)]">Analízalo con nuestro motor de IA y descubre su potencial.</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
